import {
  Alert,
  Link as InternLink,
  Paragraph,
} from "@digdir/designsystemet-react";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { cn } from "@/utils";

export const SeparateOppgjorInfo = ({ className }: { className?: string }) => {
  const { t } = useTranslation();

  return (
    <Alert data-color="info" className={cn(className, "space-y-3")}>
      <Paragraph className="text-pretty whitespace-pre-line">
        {t("pages.separate-oppgjor.beskrivelse")}
      </Paragraph>
      <InternLink asChild>
        <Link
          to={"/veiledning"}
          hash="separate-innbetalinger-og-utbetalinger-fra-1-september-2026"
          hashScrollIntoView={true}
        >
          {t("pages.separate-oppgjor.les-mer")}
        </Link>
      </InternLink>
    </Alert>
  );
};
